import { gql } from "~/__generated__"

export const JOIN_GROUP_FROM_INDEX_MUTATION = gql(/* GraphQL */ `
  mutation JoinGroupFromIndex($input: JoinGroupInput!) {
    joinGroup(input: $input) {
      group {
        id
        viewerIsMember
      }
    }
  }
`)

export const LEAVE_GROUP_MUTATION = gql(/* GraphQL */ `
  mutation LeaveGroupMutation($input: LeaveGroupInput!) {
    leaveGroup(input: $input) {
      success
    }
  }
`)

export const REMOVE_GROUP_MEMBER_MUTATION = gql(/* GraphQL */ `
  mutation RemoveGroupMemberMutation($input: RemoveGroupMemberInput!) {
    removeGroupMember(input: $input) {
      success
    }
  }
`)
